import { TESTING_SCOPE_SEARCH_START_LOADING, TESTING_SCOPE_SEARCH_END_LOADING, TESTING_SCOPE_SEARCH_LOADED, SET_TESTING_SCOPE_FILTER } from "../constants/IneTestingScopeConstants";
import { TESTING_SCOPE_START_LOADING, TESTING_SCOPE_END_LOADING, TESTING_SCOPE_LOADED } from "../constants/IneTestingScopeConstants";

import { getApiData, postApiJsonData } from "../utils/index";
import * as commonActions from "./CommonActions";

export function loadTestingScopeSearch(filters, navigate) {
    return async (dispatch) => {
        
        await dispatch({ type: TESTING_SCOPE_SEARCH_START_LOADING });

        try {

            var data = await postApiJsonData("TestingScope/GetPaged", filters, null);
            
            if(data.success) {
                await dispatch({
                    type: TESTING_SCOPE_SEARCH_LOADED,
                    payload: {
                        dataList: data.responseEntities[0].dataList
                        , searchList: data.responseEntities[0].userSearches
                        , totalCount: data.responseEntities[0].totalCount
                    }
                });
            }
            else {
                if(data.errorCode == "401") {
                    navigate('/not-authorized/');
                }

                dispatch(commonActions.setErrorMessage(data.errorDesc));
            }
            
			await dispatch({ type: TESTING_SCOPE_SEARCH_END_LOADING });
        } 
        catch (error) {
            dispatch(commonActions.setErrorMessage(error));
            await dispatch({ type: TESTING_SCOPE_SEARCH_END_LOADING });
        }
    };
}

export function setTestingScopeFilter(filter) {
    return async (dispatch) => {
        await dispatch({
            type: SET_TESTING_SCOPE_FILTER,
            payload: filter
        });
    };
}

export function loadTestingScope(id, navigate) {
    return async (dispatch) => {
        
        await dispatch({ type: TESTING_SCOPE_START_LOADING });

        try {

            var data = await getApiData("TestingScope/GetTestingScopeFBO", { id });
            
            if(data.success) {
                await dispatch({
                    type: TESTING_SCOPE_LOADED,
                    payload: data.responseEntities[0]
                });
            }
            else {
                if(data.errorCode == "401") {
                    navigate('/not-authorized/');
                }

                dispatch(commonActions.setErrorMessage(data.errorDesc));
            }
            
			await dispatch({ type: TESTING_SCOPE_END_LOADING });
        } 
        catch (error) {
            dispatch(commonActions.setErrorMessage(error));
            await dispatch({ type: TESTING_SCOPE_END_LOADING });
        }
    };
}

export function saveTestingScope(fbo, navigate) {
    return async (dispatch) => {
        
        await dispatch({ type: TESTING_SCOPE_START_LOADING });

        try {

            var isAdd = fbo.isAddMode;
            var data = await postApiJsonData("TestingScope/SaveTestingScopeFBO", null, fbo);
            
            if(data.success) {
                if(isAdd) {
                    navigate('/ine-scope-edit/' + data.responseEntities[0].testingScope.id);
                    dispatch(commonActions.setSuccessMessage("Scope Created Successfully!"));
                }
                else {
                    await dispatch({
                        type: TESTING_SCOPE_LOADED,
                        payload: data.responseEntities[0]
                    });

                    dispatch(commonActions.setSuccessMessage("Scope Saved Successfully!"));
                }
            }
            else {
                if(data.errorCode == "401") {
                    navigate('/not-authorized/');
                }

                dispatch(commonActions.setErrorMessage(data.errorDesc));
            }
            
			await dispatch({ type: TESTING_SCOPE_END_LOADING });
        } 
        catch (error) {
            dispatch(commonActions.setErrorMessage(error));
            await dispatch({ type: TESTING_SCOPE_END_LOADING });
        }
    };
}